import { getOptions } from '../../api'
import profileAPIs from '../../api/profile'

export default {
    getProfileSections({ commit, rootGetters }) {
        commit('getProfileSections', rootGetters.App.profileSections);
    },

    getProfileOptions({ commit }, includes) {
        let requestUrl = getOptions(includes)

        axios.get(requestUrl)
             .then(response => {
                 commit('getProfileOptions', response.data)
             })
            .catch(error => {})
    },

    getProfile({ commit, rootGetters }, collectionId = null) {
        let profileId = rootGetters['profile/memberId'];
        let entityId = rootGetters['profile/entityId'];
        let requestUrl = profileAPIs.basicInfo(entityId, profileId);

        // this is useful when request comes from parent entity context.
        if (collectionId) {
            requestUrl += "?includeChildEntityMembers=true&collectionId="+collectionId;
        }

        axios.get(requestUrl)
            .then(response => {
                commit('getProfile', response.data)
            })
    },

    uploadAvatar({ commit, rootGetters }, photoUrl) {
        let profileId = rootGetters['profile/memberId']
        let entityId = rootGetters['profile/entityId'];

        let requestUrl = profileAPIs.basicInfo(entityId, profileId)
        let photoObj = {
            profile_photo_large: photoUrl
        }

        axios.put(requestUrl, photoObj).
        then(response => {
            commit('updateAvatar', response.data.user.profile_photo_large)
        })
            .catch(e => {
                console.log(e.response)
            })
    },

    removeConfirmation({ state, commit, rootGetters }, removeableItem) {
        let profileId = rootGetters['profile/memberId'],
            removeableItemKey = Object.keys(removeableItem)[0],
            removeableItemSlug,
            removeableItemId = removeableItem[removeableItemKey].id,
            removeableItemStateKey;

        switch(removeableItemKey) {
            case 'phone':
                removeableItemSlug = 'phones';
                removeableItemStateKey = 'contactPhoneState';
                break;

            case 'email':
                removeableItemSlug = 'emails';
                removeableItemStateKey = 'contactEmailState';
                break;

            case 'address':
                removeableItemSlug = 'addresses';
                removeableItemStateKey = 'contactAddressState';
                break;

            case 'citizenships':
                removeableItemSlug = 'citizenships';
                removeableItemStateKey = 'citizenshipState';
                break;

            case 'employment':
                removeableItemSlug = 'employments';
                removeableItemStateKey = 'employmentState';
                break;

            case 'membership':
                removeableItemSlug = 'memberships';
                removeableItemStateKey = 'membershipState';
                break;

            case 'education':
                removeableItemSlug = 'educations';
                removeableItemStateKey = 'educationState';
                break;

            case 'skill':
                removeableItemSlug = 'skills';
                removeableItemStateKey = 'skillState';
                break;

            case 'socialMedia':
                removeableItemSlug = 'socialMedia';
                removeableItemStateKey = 'socialMediaState';
                break;
        }

        let requestUrl = profileAPIs[removeableItemSlug](profileId); // generate uri with profile ID
            requestUrl+= `/${removeableItemId}` // concats item id

        // console.log(requestUrl);return;
        // console.log(removeableItem[removeableItemKey]);return;

        const promise = axios.delete(requestUrl);

        promise.then(() => {
            commit('removeConfirmation', {
                removeableItemSlug,
                removeableItemStateKey,
                data: removeableItem[removeableItemKey]
            });
        })

        return promise;
    }
}



// WEBPACK FOOTER //
// ./src/store/profile/_actions.js